<template>
    <div id="m-inbox" style="height: 100%">
        <p-edit-permissions-popup ref="p-edit-permissions-popup"></p-edit-permissions-popup>
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
            {{ message }}
        </v-alert>
        <v-card v-else elevation="0">
            <v-card-actions class="mx-0 pa-2">
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <v-data-table
                            style="width: 100%;"
                            fixed-header
                            :headers="header"
                            :items="frontendUsers"
                            hide-default-footer
                            disable-pagination>
                        <template v-slot:item.email="{ item }">
                            <v-card-text class="blue--text ma-0 pa-0">{{ item.email}}</v-card-text>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn :disabled="!ifCanEdit()"
                                    icon
                                   color="green"
                                   class="mr-0"
                                   @click="onPressEdit(item)">
                                <v-icon size="22">mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import PEditPermissionsPopup from "@/modules/mpermissions/views/popups/p-edit-permissions-popup";

export default {
    components: {PEditPermissionsPopup},
    data: () => ({
        header: [
            {text: 'Email', sortable: true, value: 'email', class: "white blue--text", color: "red"},
            {text: 'Uid', sortable: true, value: 'uid', class: "white blue--text", color: "red"},
            {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width:'20%', align:'end'}
        ],
        loading: true,
        message: "",
    }),
    computed:{
        frontendUsers(){
            return PermissionsStoreUtils.getUsers()
        }
    },
    methods: {
        ifCanEdit(){
            let userUid = PermissionsStoreUtils.getMyUserUid()
            return PermissionsStoreUtils.getPermission(userUid, PermissionsStoreUtils.PERMISSION_TAB.subpermissions.PERMISSION_TAB_EDIT.id)
        },
        onPressEdit(user){
            this.$refs['p-edit-permissions-popup'].show(user)
        }
    },
    beforeMount() {
        this.loading = false
    },
    destroyed() {
        console.log("destroy root view permissions");
    }
}
</script>

<style scoped>
</style>